const initialValues = {
  email: '',
  name: '',
  alerting: false,
  advertising: false,
  personalization: false,
  message: '',
};

function isValid(values) {
  const anOptionSelected =
    values.advertising || values.personalization || values.alerting;

  return values.email !== '' && values.name !== '' && anOptionSelected;
}

function useForm({ initialValues: _initialValues }) {
  const [values, setValues] = useState({ ...initialValues, ..._initialValues });

  const onChange = (fieldName, value) => {
    setValues({
      ...values,
      [fieldName]: value,
    });
  };

  const valid = isValid(values);
  return { values, onChange, valid };
}

export default useForm;
